var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#111112"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75091 6.75091C6.41636 7.08546 6.41636 7.62788 6.75091 7.96243L11.7885 13L6.75091 18.0376C6.41636 18.3721 6.41636 18.9145 6.75091 19.2491C7.08546 19.5836 7.62788 19.5836 7.96243 19.2491L13 14.2115L18.0376 19.2491C18.3721 19.5836 18.9145 19.5836 19.2491 19.2491C19.5836 18.9145 19.5836 18.3721 19.2491 18.0376L14.2115 13L19.2491 7.96243C19.5836 7.62788 19.5836 7.08546 19.2491 6.75091C18.9145 6.41636 18.3721 6.41636 18.0376 6.75091L13 11.7885L7.96243 6.75091C7.62788 6.41636 7.08546 6.41636 6.75091 6.75091Z",
    fill: "#F4F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClose);
export default __webpack_public_path__ + "static/media/Small Close.80e59cb11787b23a62352f4bc2528f6c.svg";
export { ForwardRef as ReactComponent };